<template>
    <div class="TTL-input" :style="{width:option.width}">
    <el-input 
        :type="option.inputtype"
        :class="option.type=='input' ? 'inputType' : ''"
        v-model="inputvalue" 
        :placeholder="option.placeholder" 
        :clearable="option.clearable" 
        :disabled="option.disable ? true : false"
        @change="ChangeData"
        @input="ChangeInput"
        @keydown.enter.prevent="keydownData"
        :autosize="{minRows: option.minRows, maxRows: option.maxRows}"
    />
    </div>
</template>

<script>
export default {
  props: ['value','option'],
  data() {
      return {
          inputvalue: this.value,
          option: {
              inputtype:this.option && this.option.inputtype? this.option.inputtype : 'text',
              placeholder:this.option && this.option.placeholder ? this.option.placeholder : '请填写数据',
              clearable: this.option && this.option.clearable ? this.option.clearable : false,
              type:this.option && this.option.type ? this.option.type : 'search',
              width: this.option && this.option.width ? this.option.width : 'auto',
              ischange: this.option && this.option.ischange ? this.option.ischange : false,
              isinput: this.option && this.option.isinput ? this.option.isinput : false,
              iskeydown: this.option && this.option.iskeydown ? this.option.iskeydown : false,
              disable: this.option && this.option.disable ? true : false,
              minRows: this.option && this.option.minRows ? this.option.minRows : 3,
              maxRows: this.option && this.option.maxRows ? this.option.maxRows : 10,
          },
      }
  },

  watch: {
      value(val) {
          this.inputvalue=val;
      }
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      ChangeData() {
          if(!this.option.ischange) return false; //数据修改变更开关关闭时，不往下执行
          this.$emit('finish',{type:'change',value:this.inputvalue});
      },

      /** 输入框变动 **/
      ChangeInput() {
          if(!this.option.isinput) return false; //数据输入时开关关闭时，不往下执行
          this.$emit('finish',{type:'input',value:this.inputvalue});
      },

      /** 输入按下回车点击 **/
      keydownData() {
          if(!this.option.iskeydown) return false; //数据输入时开关关闭时，不往下执行
          this.$emit('finish',{type:'keydown',value:this.inputvalue});
      },

  }

}
</script>

<style scoped>
::v-deep(.inputType .el-input__wrapper) {background-image:none !important;padding-left:20px !important;}
</style>